// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/" + ({"153":"Lamela","244":"Specification","249":"Gallery","337":"Contact","346":"Apartment","378":"Location","622":"Apartments","962":"Project"}[chunkId] || chunkId) + "." + __webpack_require__.h() + ".js";
};